import React, { useState, useRef, useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import { BiData, } from '@wix/da-bi/pkg/events';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { Url } from '@wix/da-url';
import s from './SearchBar.scss';
var USERNAME_REGEX = /^[A-Za-z0-9][A-Za-z0-9-]{1,18}[A-Za-z0-9]$/;
var SearchBar = function (_a) {
    var isLegacyHeader = _a.isLegacyHeader, _b = _a.searchQuery, searchQuery = _b === void 0 ? '' : _b, searchBasePath = _a.searchBasePath, className = _a.className;
    var t = useTranslation().t;
    var _c = useState(searchQuery), query = _c[0], setQuery = _c[1];
    var searchInputRef = useRef(null);
    var logBiEvent = useBiLogger();
    var handleSubmit = useCallback(function (e) {
        var _a, _b;
        e.preventDefault();
        var searchTerm = (_b = (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim();
        if (!searchTerm) {
            return; // dont allow empty search
        }
        var searchUrl = Url.searchLink(searchTerm, searchBasePath);
        var username = searchTerm.slice(1);
        var isCorrectUsername = searchTerm.startsWith('@') && USERNAME_REGEX.test(username);
        logBiEvent(BiData({
            evid: 710,
            search_terms: searchTerm,
            sectionname: 'popup',
        }));
        // Only search usernames if we are not on subdomain!
        if (isCorrectUsername && !isLegacyHeader) {
            var userLinkUrl_1 = Url.userLink(username);
            // to test this locally do `.replace('.com', '.lan')`
            var http = new XMLHttpRequest();
            http.open('HEAD', userLinkUrl_1);
            http.onreadystatechange = function () {
                if (this.readyState === this.DONE) {
                    var doesUserExists = this.status === 200;
                    var redirectUrl = doesUserExists ? userLinkUrl_1 : searchUrl;
                    window.location.assign(redirectUrl);
                }
            };
            http.send();
        }
        else {
            window.location.assign(searchUrl);
        }
    }, [isLegacyHeader, logBiEvent, searchBasePath]);
    var handleInputKeyDown = useCallback(function (event) {
        if (event.key === 'Enter' || event.key === 'Return') {
            event.preventDefault();
            event.stopPropagation();
            handleSubmit(event);
        }
    }, [handleSubmit]);
    return (React.createElement("div", { className: classnames(s['searchbar-container'], className) },
        React.createElement("form", { className: s['search-form'], action: Url.searchLink(), onSubmit: handleSubmit },
            React.createElement(TextInput, { ref: searchInputRef, id: "search-input", label: t('siteHeader.searchBar.placeholder'), placeholder: t('siteHeader.searchBar.placeholder'), value: query, onChange: function (e) { return setQuery(e.target.value); }, onKeyDown: handleInputKeyDown, postfix: React.createElement(PlainButtonOrLink, { onClick: handleSubmit, biData: query.length === 0
                        ? BiData({
                            evid: 700,
                            link_name: 'search',
                        })
                        : undefined, "aria-label": t('siteHeader.searchBar.a11y.button') },
                    React.createElement(SearchIcon, { disableDefaultColors: true })), onClick: function () {
                    logBiEvent(BiData({
                        evid: 700,
                        link_name: 'search',
                    }));
                }, noBottomSpacing: true, isLabelHidden: true }))));
};
SearchBar.displayName = 'SearchBar';
export default SearchBar;
//# sourceMappingURL=SearchBar.js.map